<template>
        <div class="defaultinfo">
              <div class="defaultinfonavbar">
                  <el-dialog  :visible.sync="dialogFormVisible" title="添加状态" style="text-align: left;" custom-class="defaultDialog" :close-on-click-modal="false">
                          <div class="defalutAddStatus">
                              <div class="defalutAddStatusText"><span class="bixuan">*</span>状态名称</div>
                              <el-input v-model="statusName"
                                        autocomplete="off"
                                        placeholder="请输入状态名称"
                                        maxlength="8"
                                        class="defalutAddStatusInput"
                              ></el-input>
                          </div>
                          <div class="StatusColor">
                              <div class="statusColorText">状态颜色</div>
                              <div class="color">
                                  <el-row :gutter="10">
                                      <el-col :span="2" v-for="(color,index) in colorList" :key="index">
                                          <div class="colorItem" :class="color" @click="oneClick(color)">
                                              <i class="el-icon-check" v-if="check===color"></i>
                                          </div>
                                      </el-col>
                                  </el-row>


                              </div>
                          </div>

                              <div class="defaultinfoOptionAttr">
                                  <div class="defaultinfoOptionText">状态属性</div>
                                  <div class="defaultinfoRadio">
                                      <el-radio v-model="closed" :label=false>未关闭</el-radio>
                                      <el-radio v-model="closed" :label=true @change="closeStatus">已关闭</el-radio>
                                  </div>
                              </div>
                          <div class="defalutNextStatus">
                              <div class="defaultNextStatusText">下一级状态</div>
                              <el-select class="defaultNextStatusSelect"
                                         v-model="nextStatusId"
                                         multiple
                                         placeholder="请选择"
                              >
                                  <el-option
                                          v-for="item in newStatus.list"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id"
                                  >
                                  </el-option>
                              </el-select>
                          </div>

                      <div slot="footer" class="dialog-footer">
                          <el-button @click="dialogFormVisible = false">取 消</el-button>
                          <el-button type="primary" @click="addStatus">确 定</el-button>
                      </div>
                  </el-dialog>
              </div>
              <div class="defaultInfoContain" >
               <div class="defaultInfoConHead">
                   <div class="status-header">
                        <button class="adjustmentBtn" @click="adjustClick" v-if="finish===1">
                            <span class="btn-txt">
                                调整顺序
                            </span>
                        </button>
                        <button class="finishBtn"  @click="finishClick" v-if="finish===0">
                                <span class="btn-txt">
                                    完成
                            </span>
                        </button>
                        <button class="addStatusBtn" @click="addDefaultSatus">
                            <span class="btn-txt">
                                添加状态
                            </span>
                        </button>
                    </div>

                </div>
                <div class="statusinfo">

                            <div v-if="finish===1">
                                <status-info

                                             :count="count"
                                             :statusList="status.list"
                                             @modifyStatusClick="modifyStatusClick"
                                             @deleteStatusInfo="deleteStatusInfo"
                                             @deleteStatusInfo2="deleteStatusInfo2"
                                />
                            </div>
                            <div v-if="finish===0" id="status">
                                <status-info
                                             :count="count"
                                             :statusList="status.list"
                                             @modifyStatusClick="modifyStatusClick"
                                             @deleteStatusInfo="deleteStatusInfo"
                                             @resortStatus="resortStatus"
                                             @deleteStatusInfo2="deleteStatusInfo2"
                                />
                            </div>



                </div>
              </div>

            <el-dialog
                    title="系统属性"
                    :visible.sync="dialogVisible"

                    custom-class="defaultDialog" :close-on-click-modal="false"
                    >
                <div style="font-size: 14px;line-height: 24px">系统只允许存在一个已关闭的状态，是否设置该状态为已关闭状态？</div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="cancelCloseStatus">取 消</el-button>
                <el-button type="primary" @click="cnfirmCloseStatus">确 定</el-button>
              </span>
            </el-dialog>

        </div>


</template>

<script>
    import StatusInfo from "../statusinfo/StatusInfo";

    export default {
        name: "DefaultInfo",
        components: {StatusInfo},
        data(){
            return{
                lengths:0,
                count:true,
                dialogFormVisible: false,
                nextStatusId:[],
                check:'blue',
                finish:1,
                status:{
                    list:[],
                    total:0
                },
                statusName:'',
                closed:false,
                pageSize:20,
                currentPage:1,
                newStatus:{
                    list:[]
                },
                checkaaa:[],
                statusResort:[],
                nextStatusList:[],
                dialogVisible:false,
                colorList:['blue','yellow','green','orange','bluePurple','darkGrey','grey','brown','red','redPurple','black']
            }


        },
        mounted() {
            this.getStatusList()
            this.$dragging.$on('dragged', ({ value }) => {
                this.statusResort=[]
                this.statusResort=value.list

            })

        },
        methods:{
            adjustClick(){
                this.count=!this.count
                this.finish=0
            },
            finishClick(){

                this.count=!this.count;
                this.finish=1
                this.postStatusResort()
            },
            oneClick(color){
                this.check=color
            },
            getStatusList() {
                this.$http.get(' /scrm-api/followup-status').then(res=>{
                    console.log('response',res.data)
                    this.status.list = res.data;
                    this.status.total=res.data.length
                    this.newStatus.list= res.data;
                })
            },
            addDefaultSatus(){
                this.statusName=''
                this.check='blue'
                this.closed=false
                this.nextStatusId=[]
                this.dialogFormVisible=true
            },

            addStatus() {
                if(this.statusName!=='')
                {
                    let status={
                        name:this.statusName,
                        color:this.check,
                        closed:this.closed,
                        nextStatusIds:this.nextStatusId
                    }
                    this.$http.post('/scrm-api/followup-status', status).then(res => {
                        if (res.status===200){
                            this.$message.success('添加字段成功')
                            this.getStatusList()
                        }
                        console.log(res)

                    });

                    this.dialogFormVisible=false
                }
                else
                    this.$message.error('请输入状态名称')

            },

            //调整顺序之后的状态
            postStatusResort(){
                let statusIdResort=[]
                this.statusResort.forEach(item=>{
                    statusIdResort.push(item.id)
                })
                this.$http.post('/scrm-api/followup-status/resort',statusIdResort).then(res=>{
                    if(res.status===200)
                        this.$message.success('调整顺序成功')
                    else
                        this.$message('调整顺序失败')
                    this.getStatusList()
                })
            },
            modifyStatusClick(){
                this.getStatusList()
            },
            deleteStatusInfo(){
                this.getStatusList()
            },
            deleteStatusInfo2(){
                this.getStatusList()
            },
            resortStatus(statusList){
                this.statusResort=statusList
            },
            cancelCloseStatus(){
                this.closed=false
                this.dialogVisible=false
            },
            cnfirmCloseStatus(){
                this.closed=true
                this.dialogVisible=false
            },
            closeStatus(value){
                console.log(value)
                if(value)
                {
                    this.status.list.forEach(item=>{
                        if(item.closed===true)
                            this.dialogVisible=true
                    })
                }
            }


        }
    }
</script>

<style lang="less">
    @import "../../../assets/less/defaultorderstatus/defaultinfo/defaultinfo";

    .addStatus{
        font-size: 18px;
        font-weight: 800;
        text-align: left;
        height: 30px;
    }
    .bixuan{
        color: red;
    }

    .el-select{
        width: 100%;
    }
    .el-scrollbar__wrap{
        overflow-x: auto;
    }
    .blue-background-class{
        background-color: #F1F4F5;
    }
</style>